import { getSelectors } from '@repo/core'
import { selectorsConfig } from './selectors.const'

export const devicesDataSelector = getSelectors({
  getRootPath: selectorsConfig.devicesDataSelector.getRootPath,
})
